;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/projects/:slug\",\"regex\":\"^/projects/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/writing/:slug*\",\"regex\":\"^/writing/(.+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/contact\"},{\"path\":\"/cv\"},{\"path\":\"/cv/download\"},{\"path\":\"/now\"},{\"path\":\"/projects\"},{\"path\":\"/timeline\"},{\"path\":\"/uses\"},{\"path\":\"/writing\"}],\"isrRoutes\":[\"/projects/:slug\",\"/writing/:slug*\"]}";globalThis["_sentryNextJsVersion"] = "16.1.2";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
})

// Export router transition hook for navigation instrumentation
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
